<template>
    <div class="addTicket">
        <!-- 添加券号信息 -->
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item label="未确认数量" prop="confirmQty">
                            <el-col :span="22">
                                <el-input v-model="ruleForm.confirmQty" :disabled="true" placeholder="请填写生成数量"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item
                            label="券号"
                            prop="voucherCode"
                        >
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength ="8"></el-input>
                            </el-col>
                            <el-col :span="1" :offset="1"> - </el-col>
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value2" :maxlength ="8"></el-input>
                            </el-col>
                           
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    data(){
        var validatorQty = (rule,value,callback) => {
            // if(value.value1 != ''){
            //     if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false ){
            //         callback(new Error("请填写大于0的数字"));
            //     }else{
            //         callback();
            //     }
            // }else{
            //     callback(new Error("至少输入第一个券号！"));
            // }
            // if(value.value2 != ''){
            //     if(value.value2 < 0){
            //         this.$alert("必须填写大于0的数字",'提示',{
            //             confirmButtonText:'确定',
            //             type:'error',
            //             center:true
            //         })
            //     }else if(Number(value.value2) < Number(value.value1)){
            //         console.log(value.value2)
            //         this.$alert("第二位数要大于第一位数",'提示',{
            //             confirmButtonText:'确定',
            //             type:'error',
            //             center:true
            //         })
            //         // callback(new Error("第二位数要大于第一位数"));
            //     }else{
            //         callback(new Error("请填写大于0的数字"));
            //     }
            // }
            let value1 = Number.isInteger(value.value1) ;
            let value2 = Number.isInteger(value.value2) ;
            if(value.value1 == ''){
                callback(new Error("第一个券号不能为空！"));
            }else{
                if(value.value1 != '' && value.value2 == ''){
                    let val = this.trim(value.value1);
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false){
                        callback(new Error("请填写大于0的数字"));
                    }else if(/[+]/g.test(value.value1)){
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }else{
                        callback();
                    }
                }else if(value.value2 != '' && value.value1 != ''){
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value2) == false || (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false){
                        callback(new Error("请填写大于0的数字"));
                    }else if(value.value2 - value.value1 < 0){
                        callback(new Error("第二位数要大于第一位数"));
                    }else if(value.value2 < 0 || value.value1 < 0){
                        callback(new Error("必须填写大于0的数字"));
                    }else if(/[+]/g.test(value.value2) || /[+]/g.test(value.value1)){
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value2.length != 8 || value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }else{
                        callback();
                    }
                }
                // else if(value.value2 != '' && value.value1 == ''){
                //     callback(new Error("至少输入第一个券号！"));
                // }else if(value.value2 - value.value1 < 0){
                //     callback(new Error("第二位数要大于第一位数"));
                // }else if(value.value2 < 0 || value.value1 < 0){
                //     callback(new Error("必须填写大于0的数字"));
                // }
                // else{
                //     callback();
                // }
            }
            
        }
        return {
            fileList:[],
            ruleForm:{
                confirmQty:'',
                voucherCode:{
                    value1:"",
                    value2:""
                },
                fileList: '',
                description : '',
                typeCode :''

            },
            rules:{
                generateQuantity:[
                    { required : true,message:'请输入库存',trigger:'blur'},
                    { min: 1 ,max :10,message: '长度在1到10个字符',trigger: 'blur' }
                ],
                // quantity:[
                //     // { validator : validatorQty,required : true,trigger:'blur',type:'number'},
                //     { min: 1, max: 5, message: '长度在 1 到 5 个数字', trigger: 'blur' }
                // ],
                voucherCode: [
                    { validator : validatorQty,required: true,trigger:'blur',type:'number'},
                    // { message: '请填写券号', trigger: 'blur' }
                ]
            },
            value8:'',  
        }
    },
    created (){
       
    },
    mounted(){
        /**
         * 
        */

        let {description,typeCode,confirmQty }= this.$route.query ;
        this.ruleForm.description = description ;
        this.ruleForm.typeCode = typeCode ;
        this.ruleForm.confirmQty = confirmQty ;
        if(index !== undefined){
           
        }  
        //this.selectTypes();
    },
    methods:{
        /**
         * 上传文件
         */
        beforeAvatarUpload(file){
            const isXls = file.type === 'application/vnd.ms-excel' ||  file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (!isXls) {
                this.$alert('上传文件只能是 xls 或 csv格式!','提示',{
                    confirmButtonText:'确定',
                    type:'error',
                    center:true
                })
                //this.$message.error('上传文件只能是 xls 格式!');
            }
            return isXls ;
        },
        handleRemove(file, fileList) {
        },
        handleChange(file, fileList){
            this.ruleForm.fileList = fileList[0].name;
        },
        /**
         * 点击文件
         */
        handlePreview(file) {
        },
        handleExceed(files, fileList) {
            this.$message.warning(`一次只能选择一个文件哦`);
        },
        
        //确认券号信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { typeCode,voucherCode} = this.ruleForm;
                    let userId = sessionStorage.getItem("userId") ;
                    let params = {
                        act : 'confirmCoupons',
                        from :voucherCode.value1,
                        to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                        userId
                    }
                    this.$confirm(`是否确认券号 ${params.from} - ${params.to} `,'提示',{
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center :true

                    }).then(() =>{
                        let loading = this.loadingCommon();
                        this.delType(params).then( (res) =>{
                            if(res.data.status == true && res.data.data.qty !== '0'){
                                // this.promptMsg('已全部确认成功',"success") ;
                                // this.$router.push({ path : '/ticket/manageList'});
                                this.$confirm(`确认成功 ${res.data.data.qty}`, '提示', {
                                        confirmButtonText: '确定',
                                        showCancelButton : false ,
                                        type: 'success'
                                    }).then(() => {
                                        loading.close();
                                        this.promptMsg('确认成功','success')
                                        this.ruleForm.voucherCode.value1 = '' ;
                                        this.ruleForm.voucherCode.value2 = '' ;
                                        this.selectTypes()
                                        //this.$router.push({ path : '/ticket/manageList'});
                                    }).catch(() => {
                                        loading.close();
                                        this.$message({
                                            type: 'info',
                                            message: '已取消'
                                        });          
                                    });
                            }
                            else if(res.data.status == true && res.data.data.qty == "0"){
                                loading.close();
                                this.$confirm(`确认成功 ${res.data.data.qty}`, '提示', {
                                        confirmButtonText: '确定',
                                        showCancelButton :false ,
                                        type: 'success'
                                    }).then(() => {
                                        this.alert('请查看券号是否输入正确 !','warning')
                                        // this.$router.push({ path : '/ticket/manageList'});
                                    }).catch((error) => {
                                        this.$message({
                                            type: 'info',
                                            message: '已取消'
                                        });          
                                    });
                            
                                
                            }
                            else{
                                loading.close();
                                if(res.data.msg){
                                        this.$alert(res.data.msg, '提示', {
                                            confirmButtonText: '确定',
                                            type: 'warning',
                                            center: true
                                        });
                                }else{
                                    loading.close();
                                    this.$alert('添加失败', '提示', {
                                        confirmButtonText: '确定',
                                        type: 'warning',
                                        center: true
                                    });
                                }
                            }
                        }).catch(error => {
                            loading.close();
                            this.alert('确认失败!','warning');
                        })
                    }).catch((error) =>{
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });  
                    })
                    
                    // this.promptMsg('保存成功','success') //
                
                } else {
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },

        /**
         * 修改票券信息
         */
        // modifyTicket(){
        //     let that = this;
        //     let tickedList = JSON.parse(sessionStorage.getItem('tickedList'));
        //     let index = that.$route.query.index;
        // },
        /**
         * 搜索类型编号
        */
        selectTypes(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findTypes',
                userId
            }
            this.findType(params).then( (res) =>{
                if(res.data.status == true){
                    //console.log(this.options)
                    // this.options.label = res.data.list.typeCode
                    let resultData = res.data.list;
                    let currentGeneratedQty = this.unTotalTicket2(resultData) ;
                    this.ruleForm.confirmQty = currentGeneratedQty ;
                }else{

                }
            })
        },

        /**
         * 搜索类型编号
        */
        // handleChange(value){
        //     this.ruleForm.typeCode = value;
        //     for(let [index,item] of this.options.entries()){
        //         //console.log(item)
        //         if(value == item.value){
        //             this.ruleForm.description = item.value;
        //         }
        //     }
        // }

    }

}
</script>
